var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 3.5V2H19C20.6569 2 22 3.34315 22 5V7.1875H20.5V5C20.5 4.17157 19.8284 3.5 19 3.5H15.5625Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 9.8125H22V14.1875H20.5V9.8125Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 16.8125H22V19C22 20.6569 20.6569 22 19 22H16.8125V20.5H19C19.8284 20.5 20.5 19.8284 20.5 19V16.8125Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1875 20.5V22H9.8125V20.5H14.1875Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1875 20.5V22H5C3.34315 22 2 20.6569 2 19V15.5625H3.5V19C3.5 19.8284 4.17157 20.5 5 20.5H7.1875Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 12H2V8C2 6.97706 2.25599 6.01391 2.70741 5.17112C3.7183 3.28377 5.70923 2 8 2H12V3.5H8C5.51472 3.5 3.5 5.51472 3.5 8V12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorners);
export default __webpack_public_path__ + "static/media/corners.43e23871f71e0554182a1adbb0150df0.svg";
export { ForwardRef as ReactComponent };